import { forkJoin, Observable } from "rxjs";
import { BeNeo4jService } from "../services/be-neo4j.service";


export function getAllDatabaseInfo(beNeo4jService: BeNeo4jService): Observable<any> {
    const requests = [
        beNeo4jService.getLabels(),
        beNeo4jService.getRelationships(),
        // beNeo4jService.hierarchy(),
        beNeo4jService.schemaTree(),
    ];
    return forkJoin(requests);
}